import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { FileService as fileservice } from 'projects/services/src/app/API/document/file.service';
import { FileService } from 'projects/services/src/app/API/file.service';

@Component({
	selector: 'app-file-upload',
	templateUrl: './file-upload.component.html',
	styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit, OnChanges {
	types: string;
	size: number;
	showRemarks = {};
	@Input() multiColumn = 'custom-file col-lg-4';
	@Input() fileValidation: any;
	@Input() docketForm: FormGroup;
	@Input() reviews: any;
	@Input() upload: any;
	@Input() FileinputDisabled;
	@Output() fileUploaded = new EventEmitter<any>();
	@Output() fileUploadCancelled = new EventEmitter<any>();

	file: File;
	disabled: boolean = false;
	files: File[] = [];
	errorMessage: string;
	message: any[] = [];
	placeholder = 'Choose File';
	filesPlaceholder: any[] = [];
	documentForm: FormGroup;
	objectsList: any = [];
	remove = false;
	removeFiles: any[] = [];
	astrisk = true;
	isMandatory = 'is mandatory'
	uploadDisable = false
	constructor(
		private _fileUploadService: FileService,
		private fileService: fileservice
	) {

	}

	ngOnChanges(changes: SimpleChanges) {
		console.log(this.FileinputDisabled);
		if (changes.docketForm) {
			this.placeholder = this.fileValidation.placeholder;
			this.astrisk = this.fileValidation.astrisk;
			this.disabled = this.FileinputDisabled ? this.FileinputDisabled : false;
			console.log(this.docketForm, 'file-upload');
			if (this.docketForm.value.docketDocuments && this.docketForm.value.docketDocuments.length === 12) {
				this.documentForm = this.docketForm;
				this.objectsList = Object.keys(this.documentForm.value.docketDocuments[0]);
				console.log('file-upload-component', this.objectsList);
				console.log('file-upload-component', this.documentForm.value, this.reviews);
				this.docketForm.value.docketDocuments.filter((x, i) => {
					this.message.push('');
					this.showRemarks[i] = false;
					this.filesPlaceholder.push(this.fileValidation.placeholder);
				});
			} else {
				this.objectsList = Object.keys(this.docketForm.value);
				console.log('objects list', this.objectsList);

			}
		} if (changes.multiColumn && changes.multiColumn.currentValue) {
			this.multiColumn = `custom-file col-lg-${this.multiColumn}`;
		} if (changes.fileValidation && changes.fileValidation.currentValue) {
			this.astrisk = this.fileValidation.astrisk;
			this.placeholder = this.fileValidation.placeholder;
			this.errorMessage = this.fileValidation.required ? this.errorMessage : '';
			if (this.fileValidation.placeholder !== 'Choose File') {
				this.errorMessage = 'Success';
			} else {
				// this.errorMessage = this.fileValidation.defaultMessage;
			}
		}
	}

	viewFile(url) {
		this.fileService.downloadFromUrl(url)
	}

	ngOnInit() {
	}

	showRemarksToggle(i) {
		this.showRemarks[i] = !this.showRemarks[i];
		if (!this.showRemarks[i]) {
			this.docketForm.get('docketDocuments')['controls'][i].get('documentRemarks').patchValue('');
		}
	}

	deleteFile(i) {
		this.message[i] = ''
		this.filesPlaceholder[i] = 'Upload additional documents to support your claim';
		this.documentForm.get('docketDocuments')['controls'][i].reset();
	}

	findDocket(type: string, event: any, index?: number) {
		const fileList: FileList = event.target.files;
		if (fileList.length === 0) {
			this.placeholder = 'Choose File';
			this.fileUploadCancelled.emit(true);
		}
		if (type === 'file') {
			this.uploadDisable = false
			this.errorMessage = this.fileValidation.required ? 'This field is mandatory' : '';
			this.remove = false;
			this.resetForm('file');
		} else {
			this.errorMessage = (this.fileValidation.required && this.fileValidation.label[index])
			// this.resetForm('files', index);
			this.message[index] = '';
			this.removeFiles[index] = true;
			// this.resetForm('files', index);
		}
	}

	onFileChange(event: any, type: string, index?: number) {
		console.log(event.target.files);
		switch (type) {
			case 'file':
				const filesList = event.target.files;
				if (filesList.length > 0) {
					this.file = filesList[0];
					this.placeholder = (this.file.name.length > 20) ? `${this.file.name.substring(0, 20)}....` : this.file.name;
					this.size = this.file.size;
					this.types = '.' + this.fileValidation.type.map(fileType => fileType.split('/').pop()).join(',.');
					// const indexType = this.file.type.substring(this.file.type.lastIndexOf('/') + 1);
					let indexType = '';
					if (this.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
						indexType = 'xlsx';
					} else if (this.file.type === 'application/msword') {
						indexType = 'msword'
					} else if (this.file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
						indexType = 'docx'
					} else {
						indexType = this.file.type.substring(this.file.type.lastIndexOf('/') + 1)
					}
					// const indexType = this.file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ?
					// 	this.file.type.substring(this.file.type.lastIndexOf('/') + 1) : 'xlsx'
						// 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
					const typeIndex = this.fileValidation.type.findIndex(x => x === indexType);
					if (typeIndex === -1) {
						this.placeholder = (this.file.name.length > 20) ? `${this.file.name.substring(0, 20)}....` : this.file.name;
						this.file = null;
						// this.errorMessage = this.fileValidation.message ?
						// 	`Please select appropriate type ${this.fileValidation.message.toString()}`
						// 	: `Please select appropriate type ${this.fileValidation.type.toString()}`;
						// this.errorMessage = this.fileValidation.required ? 'Please select appropriate type' : '';
						this.errorMessage = 'Please select appropriate type';
						this.remove = true;
						this.resetForm('file');
						this.fileUploadCancelled.emit(false);
					} else if (this.file.size > this.fileValidation.size) {
						this.file = null;
						this.placeholder = this.fileValidation.placeholder;
						const convertedFileSize = this.formatFileSize(this.fileValidation.size);
						// this.errorMessage = this.fileValidation.required ? `File size should not be more than ${convertedFileSize}` : '';
						this.errorMessage = `File size should not be more than ${convertedFileSize}`;
						this.remove = true;
						this.resetForm('file');
					} else {
						this.placeholder = (this.file.name.length > 20) ? `${this.file.name.substring(0, 20)}....` : this.file.name;
						this.errorMessage = this.fileValidation.required ? 'Please click on upload' : '';
						this.remove = false;
					}
					this.fileUploadCancelled.emit(false);
				} else {
					this.file = null;
					this.fileUploadCancelled.emit(true);
					this.errorMessage = '';
					this.resetForm('file');
					this.placeholder = this.fileValidation.placeholder;
					this.remove = false;
					// this.fileUploadCancelled.emit(true);
					this.errorMessage = (this.fileValidation.required && this.fileValidation.fieldName)
						? `${this.fileValidation.fieldName} is mandatory` : '';
					this.fileUploadCancelled.emit(true);
				}
				break;
			case 'files':
				const fileList = event.target.files;
				if (fileList.length > 0) {
					this.files[index] = fileList[0];
					this.filesPlaceholder[index] = this.files[index].name;
					this.size = this.files[index].size;
					this.types = '.' + this.fileValidation.type.map(fileType => fileType.split('/').pop()).join(',.');
					const indexType = this.files[index].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ?
						this.files[index].type.substring(this.files[index].type.lastIndexOf('/') + 1) :
						'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
					const typeIndex = this.fileValidation.type.findIndex(x => x === indexType);
					if (typeIndex === -1) {
						this.files[index] = null;
						this.filesPlaceholder[index] = this.fileValidation.placeholder;
						this.message[index] = this.fileValidation.message ?
							`Please select appropriate type ${this.fileValidation.message.toString()}`
							: `Please select appropriate type ${this.fileValidation.type.toString()}`;
						this.removeFiles[index] = true;
						this.resetForm('files');
					} else if (this.files[index].size > this.fileValidation.size) {
						this.files[index] = null;
						this.filesPlaceholder[index] = this.fileValidation.placeholder;
						const convertedFileSize = this.formatFileSize(this.fileValidation.size);
						this.message[index] = `File size should not be more than ${convertedFileSize}`;
						this.removeFiles[index] = true;
						this.resetForm('file');
					} else {
						this.filesPlaceholder[index] = this.files[index].name;
						this.message[index] = 'Please click on upload';
						this.removeFiles[index] = false;
					}
				} else {
					this.files[index] = null;
					this.message[index] = '';
					this.resetForm('file', index);
					this.filesPlaceholder[index] = this.fileValidation.placeholder;
					this.removeFiles[index] = false;
				}
				break;
			default:
				break;
		}
	}

	uploadDocument(type: string, index?: number) {
		this.errorMessage = ''
		switch (type) {
			case 'file':
				this._fileUploadService.uploadToServerV2(this.file, this.types, this.size).subscribe(
					// this._fileUploadService.uploadToServerV2(this.file.name, this.file, this.types, this.size).subscribe(
					res => {
						this.uploadDisable = true
						this.errorMessage = 'Success';
						if (this.docketForm) {
							const obj = Object.keys(this.docketForm.value);
							console.log(obj);
							this.docketForm.get([obj[0]]).setValue(this.file.name);
							this.docketForm.get([obj[1]]).setValue(res);
							this.fileUploaded.emit(this.docketForm);
						} else {
							this.fileUploaded.emit({ url: res, name: this.file.name });
						}
					}
				);
				break;
			case 'files':
				this._fileUploadService.uploadToServerV2(this.files[index], this.types, this.size).subscribe(
					// this._fileUploadService.uploadFile(this.files[index].name, this.files[index], this.types, this.size).subscribe(
					res => {
						this.message[index] = 'Success';
						const obj = Object.keys(this.documentForm.value.docketDocuments[index]);
						console.log(obj);
						this.documentForm.get('docketDocuments')['controls'][index].get([obj[0]]).setValue(this.files[index].name);
						// tslint:disable-next-line:max-line-length
						this.documentForm.get('docketDocuments')['controls'][index].get([obj[1]]).setValue(res);
						this.fileUploaded.emit(this.documentForm);
					}
				);
				break;
			default:
				break;
		}
	}

	resetForm(type: string, index?: number) {
		if (type === 'file') {
			if (this.docketForm) {
				this.docketForm.reset();
				this.docketForm.get(this.objectsList[0]).setValue('');
				console.log('on form reset', this.docketForm.value, this.fileValidation);
				this.placeholder = 'Choose File';
				console.log(this.docketForm.value);
				// this.docketForm.setErrors({ required: true });
			}
		} else {
			this.documentForm.get('docketDocuments')['controls'][index].get(this.objectsList[0]).setValue('');
			this.documentForm.get('docketDocuments')['controls'][index].reset();
			this.documentForm.get('docketDocuments')['controls'][index].setErrors({ required: true });
			this.docketForm = this.documentForm;
			this.placeholder = 'Upload additional documents to support your claim';
		}
	}

	uploadFile(index?: number, file?: any) {

	}

	getTextColor() {
		if (this.errorMessage.search('Please') !== -1 || this.errorMessage.search('mandatory') !== -1) {
			return 'red';
		} else if (this.placeholder === 'Choose File') {
			return 'blue';
		}
	}

	getClass() {
		if (this.errorMessage.search('mandatory') !== -1) {
			return 'col-lg-4';
		} else {
			return 'col-lg-8';
		}
	}

	formatFileSize(bytes, decimalPoint?) {
		if (bytes === 0) { return '0 Bytes'; }
		const k = 1000,
			dm = decimalPoint || 2,
			sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
			i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}

}

export interface FileUpload {
	type: string[];
	size: number;
	placeholder: string;
	required: boolean;
	defaultMessage: string;
	fieldName?: string;
	disable?: boolean;
}

export const FILE_TYPES = Object.freeze({
	PNG: 'png',
	JPEG: 'jpeg',
	JPG: 'jpg',
	PDF: 'pdf',
	DOCX: 'docx',
	EXCEL: 'xlsx',
	XLS:   'xls',
	DOC: 'msword',
	MP4: 'mp4'
});

